import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { SStorageService } from '../services/sessionStorage.service';
import { routesFixedToken } from './routesFixedToken';
import { environment } from 'src/environments/environment';
import { C } from '@angular/cdk/keycodes';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    sstorageService = inject(SStorageService);

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let authReq = req.clone({
            withCredentials: true
        });

        if (req.url.includes('/Auth/login') || req.url.includes('/refresh-token')) {
            return next.handle(authReq);
        }

        const urlLower = (req.urlWithParams ?? req.url).toLowerCase();
        for (const route of routesFixedToken) {
            if (urlLower.includes(route.toLowerCase())) {
                return next.handle(
                    authReq.clone({
                        setHeaders: {
                            Authorization: `Bearer ${environment.tokenFijo}`,
                            mod: 'info-candidate'
                        }
                    })
                );
            }
        }

        const token = this.sstorageService.getItem('token');
        const mod = this.sstorageService.getItem('mod') ?? '';

        if (token) {
            return next.handle(
                authReq.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        mod: mod
                    }
                })
            );
        }

        return next.handle(authReq);
    }
}
